import React from 'react';
import { Box, Button } from '@mui/material';
import Allreminders from '../Allreminders';

export default function AllRemindersView({
  allReminders,
  selectedPatient,
  fetchReminders,
  loading,
  setShowCreateReminder,
  onEditReminder,
}) {
  return (
    <Box className='fullWidth fullHeight'>
      <Allreminders
        allReminders={allReminders}
        selectedPatient={selectedPatient}
        fetchReminders={fetchReminders}
        loading={loading}
        onEditReminder={onEditReminder}
      />
      <Button
        variant='text'
        className='reminder-button'
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => setShowCreateReminder(true)}
      >
        Switch To Reminder
      </Button>
    </Box>
  );
}
